import React from "react";
import { LinearProgress } from "@evergis/ui";

import { MODULES_PATH } from "appConfig/modulesPath";

import { ModuleName } from "../appConfig/types";

export const MODULE_FALLBACKS = {
  [MODULES_PATH[ModuleName.Tools]]: <LinearProgress />,
  [MODULES_PATH[ModuleName.Style]]: <LinearProgress />,
  [MODULES_PATH[ModuleName.StyleEditor]]: <LinearProgress />,
  [MODULES_PATH[ModuleName.Dashboard]]: <LinearProgress />,
  [MODULES_PATH[ModuleName.LayerConfiguration]]: <LinearProgress />,
  [MODULES_PATH[ModuleName.ProjectConfiguration]]: <LinearProgress />,
  [MODULES_PATH[ModuleName.EqlQuery]]: <LinearProgress />,
  [MODULES_PATH[ModuleName.SymbolLibrary]]: <LinearProgress />,
  [MODULES_PATH[ModuleName.Catalog]]: <LinearProgress />,
  [MODULES_PATH[ModuleName.Print]]: <LinearProgress />,
};
